// @ts-nocheck
export const RESOURCE_DETAIL_AMPLITUDE_PAGE_NAME = 'Resource Detail';
export const RESOURCE_DETAIL_PAGE_KEY = 'resource-detail';

export const EVENTS = {
  LIKE: 'RESOURCES__LIKE',
  DOWNLOAD: 'RESOURCES__DOWNLOAD',
  SHARE: 'RESOURCES__SHARE',
};

export const blogCategories: BlogCategories = [
  {
    name: 'Diseño',
    originalId: 1,
    slug: 'diseno-grafico',
    url: '/blog/diseno-grafico/',
  },
  {
    name: 'Animación & 3D',
    originalId: 2,
    slug: 'animacion-3d',
    url: '/blog/animacion-3d/',
  },
  {
    name: 'Web',
    originalId: 3,
    slug: 'web',
    url: '/blog/web/',
  },
  {
    name: 'Fotografía',
    originalId: 4,
    slug: 'fotografia',
    url: '/blog/fotografia/',
  },
  {
    name: 'Marketing Digital',
    originalId: 5,
    slug: 'marketing-digital',
    url: '/blog/marketing-digital/',
  },
  {
    name: 'Lanzamientos',
    originalId: 6,
    slug: 'lanzamientos',
    url: '/blog/lanzamientos/',
  },
  {
    name: 'Comunidad Crehana',
    originalId: 7,
    slug: 'comunidad-crehana',
    url: '/blog/comunidad-crehana/',
  },
  {
    name: 'Ver todos',
    originalId: 8,
    slug: '',
    url: '/blog/',
  },
];
